import { Button, Group, Image, Paper, Text, ThemeIcon } from "@mantine/core";
import { useEffect, useState } from "react";
import IconCheckmark from "../../../../../../assets/icons/IconCheckmark";
import { defaultNodeConfigs } from "../flowSettings";
import { IconEdit, IconSparkles } from "@tabler/icons-react";
import { useFlowStore } from "../../../../../../stores/WorkflowStore";
import { handleLayout } from "../layouter";
import AddStep from "../nodes/AddStep";
import { modals } from "@mantine/modals";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import { useProfileStore } from "../../../../../../stores/UserStore";

const FirstStepCreation = ({ isManual, isAi, setIsAi, setActive }) => {
  const lang = useLanguage((s) => s.language);
  const nodes = useFlowStore((s) => s.nodes);
  const setNodes = useFlowStore((s) => s.setNodes);
  const setEdges = useFlowStore((s) => s.setEdges);
  const getId = useFlowStore((s) => s.getId);
  const profile = useProfileStore((s) => s.profile);

  const aiCheckmarks = lang.campaign.first_step.ai_checkmarks;
  const manualCheckmarks = lang.campaign.first_step.manual_checkmarks;

  const handleActionClick = (actionType) => {
    let newNodes = [];
    let newEdges = [];
    let newNodeId = getId().toString();
    modals.close("first-step-creation");

    const startNode = {
      id: "0",
      type: "start",
      position: { x: 0, y: 0 },
      data: {
        source: null,
        actionType: "start",
        shouldBeEvent: true,
      },
    };
    newNodes.push(startNode);

    const newNode = {
      id: newNodeId,
      type: "action",
      data: {
        ...defaultNodeConfigs,
        source: "0",
        actionType: actionType,
        sending_weekends_allowed: false,
        shouldBeEvent: true,
      },
      position: { x: 0, y: 0 },
    };
    newNodes.push(newNode);

    const newEdge = {
      id: `e-0-${newNodeId}`,
      source: "0",
      target: newNodeId,
      data: { fromEvent: true, error: null },
    };
    newEdges.push(newEdge);

    setNodes(newNodes);
    setEdges(newEdges);

    setTimeout(() => {
      handleLayout();
      // setTimeout(() => {
      //     reactflow?.setCenter(256, window.innerHeight / 2 - 256, {
      //         duration: 1000,
      //         zoom: 1,
      //     });
      // }, 400);
    }, 200);
  };

  const handleClick = (type) => {
    if (type === "ai") {
      setIsAi(true);
      setActive("agent");
      modals.close("first-step-creation");
    } else {
      let onModalClose = () => {
        setIsAi(null);
        modals.close("first-step-creation");
      };
      modals.open({
        modalId: "first-step-creation",
        children: (
          <AddStep
            handleActionClick={handleActionClick}
            handleClose={onModalClose}
          />
        ),
        size: 1024,
        onClose: onModalClose,
      });
    }
    setIsAi(type === "ai");
  };

  useEffect(() => {
    if (nodes.length === 1 && nodes[0].type === "start") {
      setNodes([]);
    }
  }, [nodes]);

  useEffect(() => {
    if (isManual) {
      let onModalClose = () => {
        modals.close("first-step-creation");
      };
      modals.open({
        modalId: "first-step-creation",
        children: (
          <AddStep
            handleActionClick={handleActionClick}
            handleClose={onModalClose}
          />
        ),
        size: 1024,
        onClose: onModalClose,
      });
    }
  }, [isManual]);

  // useEffect(() => {
  //   return () => {
  //     modals.closeAll();
  //   };
  // }, []);

  if (isAi === null) {
    return (
      <Group
        pos={"fixed"}
        top={"50%"}
        left={"50%"}
        style={{ transform: "translate(-50%, -50%)", zIndex: 1000 }}
        gap={64}
        wrap="nowrap"
        align="stretch"
      >
        {profile?.level === "admin" ? (
          <Paper
            shadow="lg"
            p="lg"
            withBorder
            w={"400"}
            radius={"lg"}
            className="workflow-start-type"
            onClick={() => handleClick("ai")}
            style={{
              overflow: "hidden",
              borderColor: "var(--mantine-color-primary-6)",
            }}
            pos={"relative"}
          >
            <Image
              src={"/assets/images/workflow_start_ai.png"}
              w={"100%"}
              h={"10vw"}
              fit="contain"
            />

            <Group justify="center" mt={"md"} pos={"relative"}>
              <ThemeIcon
                variant="subtle"
                color="primary"
                pos={"absolute"}
                left={"10%"}
                size={"md"}
              >
                <IconSparkles />
              </ThemeIcon>
              <Text c={"primary"} fw={700} fz={20}>
                {lang.campaign.first_step.ai_title}
              </Text>
            </Group>

            {aiCheckmarks.map((text, index) => (
              <Group mt={"md"} gap={"xs"} key={index} wrap="nowrap">
                <ThemeIcon
                  variant="subtle"
                  color={"green"}
                  size={"lg"}
                  radius={"md"}
                >
                  <IconCheckmark
                    style={{
                      width: 20,
                      height: 20,
                      fill: "#000",
                    }}
                  />
                </ThemeIcon>
                <Text>{text}</Text>
              </Group>
            ))}

            <Group justify="center" mt={16}>
              <Button size="md" leftSection={<IconSparkles />} fw={600}>
                {lang.campaign.first_step.ai_btn}
              </Button>
            </Group>
          </Paper>
        ) : (
          <Paper
            shadow="lg"
            p="lg"
            withBorder
            w={"400"}
            radius={"lg"}
            className="workflow-start-type"
            // onClick={() => handleClick("ai")}
            style={{
              pointerEvents: "none",
              overflow: "hidden",
              borderColor: "var(--mantine-color-primary-6)",
            }}
            pos={"relative"}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.1)",
                zIndex: 1,
              }}
            />
            <Image
              src={"/assets/images/workflow_start_ai.png"}
              w={"100%"}
              h={"10vw"}
              fit="contain"
            />

            <Group justify="center" mt={"md"} pos={"relative"}>
              <ThemeIcon
                variant="subtle"
                color="primary"
                pos={"absolute"}
                left={"10%"}
                size={"md"}
              >
                <IconSparkles />
              </ThemeIcon>
              <Text c={"primary"} fw={700} fz={20}>
                {lang.campaign.first_step.ai_title}
              </Text>
            </Group>

            {aiCheckmarks.map((text, index) => (
              <Group mt={"md"} gap={"xs"} key={index} wrap="nowrap">
                <ThemeIcon
                  variant="subtle"
                  color={"green"}
                  size={"lg"}
                  radius={"md"}
                >
                  <IconCheckmark
                    style={{
                      width: 20,
                      height: 20,
                      fill: "#000",
                    }}
                  />
                </ThemeIcon>
                <Text>{text}</Text>
              </Group>
            ))}

            <Group justify="center" mt={16}>
              <Button
                size="md"
                leftSection={<IconSparkles />}
                fw={600}
                disabled
              >
                {lang.campaign.first_step.ai_btn}
              </Button>
            </Group>
          </Paper>
        )}

        <Paper
          shadow="lg"
          p="lg"
          withBorder
          w={"400"}
          radius={"lg"}
          className="workflow-start-type"
          onClick={() => handleClick("manual")}
          style={{
            borderColor: "var(--mantine-color-primary-6)",
            borderWidth: 2,
          }}
        >
          <Image
            src={"/assets/images/workflow_start_manual.png"}
            w={"100%"}
            h={"10vw"}
            fit="contain"
          />
          <Group justify="center" mt={"md"} pos={"relative"}>
            <ThemeIcon
              variant="subtle"
              color="primary"
              pos={"absolute"}
              left={"10%"}
              size={"md"}
            >
              <IconEdit />
            </ThemeIcon>
            <Text c={"primary"} fw={700} fz={20}>
              {lang.campaign.first_step.manual_title}
            </Text>
          </Group>

          {manualCheckmarks.map((text, index) => (
            <Group mt={"md"} gap={"xs"} key={index} wrap="nowrap">
              <ThemeIcon
                variant="subtle"
                color={"green"}
                size={"lg"}
                radius={"md"}
              >
                <IconCheckmark
                  style={{
                    width: 20,
                    height: 20,
                    fill: "#000",
                  }}
                />
              </ThemeIcon>
              <Text>{text}</Text>
            </Group>
          ))}

          <Group justify="center" mt={16}>
            <Button size="md" leftSection={<IconEdit />} fw={600}>
              {lang.campaign.first_step.manual_btn}
            </Button>
          </Group>
        </Paper>
      </Group>
    );
  }
};

export default FirstStepCreation;
